import styled from "styled-components"
import { useRouter } from "next/router"
import findIndex from "lodash/findIndex"
import Div from "components/atoms/div"
import ProgressItemV2 from "components/molecules/progress-item-v2"
import { ProgressItemV2Text } from "components/molecules/progress-item-v2/progress-item-v2"

export const ProgressBarV2Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  ${(props) => props.mt && `margin-top: ${props.mt}px`};
  ${(props) => props.mb && `margin-bottom: ${props.mb}px`};
  ${(props) => props.mr && `margin-right: ${props.mr}px`};
  ${(props) => props.ml && `margin-left: ${props.ml}px`};
  @media (min-width: 520px) {
    padding-top: 56px;
    padding-right: 56px;
    padding-left: 56px;
  }
`

const ProgressBarV2 = ({ steps, partner, ...rest }) => {
  const router = useRouter()
  const totalProgress = steps.length
  const currentStepIndex = findIndex(
    steps,
    (step) => router?.pathname === step?.pathname,
  )
  return (
    <ProgressBarV2Wrapper {...rest}>
      <Div flex>
        {steps.map((step, index) => (
          <ProgressItemV2
            key={step.name}
            id={`${step.name}-progress-item-v2`}
            progressName={step?.name}
            isCurrentStep={currentStepIndex >= index}
            ready={currentStepIndex > index}
            progressIndex={index + 1}
            totalProgress={totalProgress}
            onClick={() =>
              step.ready &&
              router.push(step?.pathname.replace("[partner]", partner))
            }
          />
        ))}
      </Div>
      <Div padding="0 0 0 20px">
        <ProgressItemV2Text m0 weight={600} active hideDesktop>
          Step {currentStepIndex + 1} of {totalProgress}:{" "}
          {steps[currentStepIndex]?.name}
        </ProgressItemV2Text>
      </Div>
    </ProgressBarV2Wrapper>
  )
}

export default ProgressBarV2
